import { Breakpoint } from '@philips-internal/oswald-ui-constants';
const BaseCardListColumnsByBreakpoint = {
    [Breakpoint.GLOBAL]: 12,
    [Breakpoint.LG]: 12,
    [Breakpoint.MD]: 12,
    [Breakpoint.SM]: 8,
    [Breakpoint.XSM]: 4,
};
var BaseCardListOrientation;
(function (BaseCardListOrientation) {
    BaseCardListOrientation["HORIZONTAL"] = "horizontal";
    BaseCardListOrientation["VERTICAL"] = "vertical";
})(BaseCardListOrientation || (BaseCardListOrientation = {}));
export { BaseCardListColumnsByBreakpoint, BaseCardListOrientation, };
//# sourceMappingURL=base-card-list-constants.js.map